// Persistência das configurações visuais/funcionais de cada oficina
// (logo, cor primária, tema, funções habilitadas). Mesmo padrão dos
// outros services: hoje localStorage, troque por fetch() quando houver
// backend real — a UI só conhece esta interface (get/save).

const STORAGE_PREFIX = "oficina_settings:";

function storageKey(workshopId) {
  return `${STORAGE_PREFIX}${workshopId}`;
}

export const settingsService = {
  get(workshopId) {
    try {
      const raw = localStorage.getItem(storageKey(workshopId));
      return raw ? JSON.parse(raw) : {};
    } catch (err) {
      console.error("Falha ao ler configurações:", err);
      return {};
    }
  },

  save(workshopId, settings) {
    localStorage.setItem(storageKey(workshopId), JSON.stringify(settings));
    return settings;
  },
};
